import API from '@/lib/API.js'
import comun from './comun.js'
const tipodocumentacion = {
    namespaced: true,
    state: {
        Lista: [],
        Filtradas: [],
        Seleccionado: undefined
    },
    mutations: {
        init(state) {
            state.Filtradas = [];
            state.Seleccionado = undefined;
        },
        set(state, payload) {
            state.Lista = payload;
        },
        select(state, payload) {
            state.Seleccionado = payload;
        },
    },
    actions: {
        async set({
            commit,
            getters
        }) {
            let entidades = getters.getTipo_documentacion();
            if (entidades.length === 0) {
                commit("comun/cargando")
                let data = await API.Tipo_documentaciones.traerTodos();
                commit("set", data)
                commit("comun/fincarga")
            }
        },
        select({
            commit
        }, payload) {
            commit("select", payload)
        },
        selectPorId({
            commit,
            state
        }, payload) {
            commit("comun/cargando")
            let entidad = state.Lista.find((x) => x.id_tipo_documentaciones == payload)
            commit("select", entidad)
            commit("comun/fincarga")
        },
        setNuevo({
            commit
        }) {
            commit("comun/cargando")
            let entidad = {
                id_tipo_documentaciones: 0,
                Descripcion_documentacion: ""
            }
            commit("select", entidad)
            commit("comun/fincarga")
        },
        async guardar({
            commit,
            dispatch,
            state
        }) {
            let data = []
            let str = ""
            if (state.Seleccionado.id_tipo_documentaciones != 0) {
                data = await API.Tipo_documentaciones.modificar(state.Seleccionado);
                str += "Tipo de documentacion modificada"
            } else {
                data = await API.Tipo_documentaciones.alta(state.Seleccionado);
                str += `Nuevo Tipo de documentacion de alta '${data.Descripcion_documentacion}'`
            }
            let entidades = await API.Tipo_documentaciones.traerTodos();
            commit("set", entidades)
            dispatch("selectPorId", data.id_tipo_documentaciones)
            commit("comun/mostrar", str)
        },
        async guardarEntidad({
            commit,
            dispatch
        }, entidad) {
            let data = []
            let str = ""
            if (entidad.id_tipo_documentaciones != 0) {
                data = await API.Tipo_documentaciones.modificar(entidad);
                str += "Tipo de documentacion modificada"
            } else {
                data = await API.Tipo_documentaciones.alta(entidad);
                str += `Nuevo Tipo de documentacion de alta '${data.Descripcion_documentacion}'`
            }
            let entidades = await API.Tipo_documentaciones.traerTodos();
            commit("set", entidades)
            dispatch("selectPorId", data.id_tipo_documentaciones)
            commit("comun/mostrar", str)
        },
        async eliminar({
            commit
        }, id) {
            let str = ""
            if (id != 0) {
                await API.Tipo_documentaciones.eliminar(id);
                str += "Tipo de documentacion eliminada"
            }
            let ents = await API.Tipo_documentaciones.traerTodos();
            commit("set", ents)
            commit("comun/mostrar", str)
        },
    },
    getters: {
        getTipo_documentacion: state => () => {
            return state.Lista;
        },
    },
    modules: {
        comun,
    }
}
export default tipodocumentacion;